import DashboardEstoqueView from "../../components/estoque/DashboardEstoqueView";

export default function DashboardEstoque() {
  return <DashboardEstoqueView />;
}
